/* eslint max-len: 0 */

import emoji from "../images/emoji-smile.svg"

export const providers = [
  {
    name: "vapi",
    label: "VAPI",
    description:"For using your Vapi account",
    url: "https://vapi.ai/",
    fields : [
      {"name" : "api_key","label": "Private Key","type":"text"},
      {"name" : "pub_key","label": "Public Key","type":"text"},
    ]
  },
  {
    name: "bland",
    label: "Bland AI",
    description:"For using your Bland AI.",
    url: "https://www.bland.ai/",
    fields : [
      {"name" : "api_key","label": "Key Value","type":"text"},
    ]
  },
  {
    name: "retell",
    label: "Retell AI",
    description:"For using your Retell AI.",
    url: "https://www.retellai.com/",
    fields : [
      {"name" : "api_key","label": "Key Value","type":"text"},
    ]
  }
];

export const providersSelectList = [
  
  {
    label : "Vapi AI",
    value : "vapi",
  },
  // {
  //   label : "Bland AI",
  //   value : "bland",
  // },
  {
    label : "Retell AI",
    value : "retell",
  },
];


export const plansCycle = [
  {
      label : "Monthly",
      value : 30,
      isHide : false,
  },
  {
      label : "Quarterly",
      value : 90,
      isHide : true,
  },
  {
      label : "Half Yearly",
      value : 180,
      isHide : true,
  },
  {
      label : "Annually",
      value : 360,
      isHide : false,
  }
];

export const plan_type = [
  {
    label: "Subscription",
    value: "Subscription"
  },
  /* {
    label: "LIFE TIME DEAL",
    value: "LTD"
  }, */
  {
    label: "Pay As You Go",
    value: "pay_as_you_go"
  },
]

export const stepConfigurations = [
  {
      title: 'Plan Info',
      fields: [
          { name: 'plan_name', label: 'Plan Name', type: 'text', placeholder: 'Ex: Startup', icon: "", requiredmsg: "Required field.", description: "", maxlength: 100},
          { name: 'plan_description', label: 'Plan Description', type: 'text', placeholder: 'About this plan...', icon: "", requiredmsg: 'Required field', description: "", maxlength: 1000},
          { name: 'type', label: 'Type', type: 'select', placeholder: 'Select', requiredmsg: 'Required field', options: plan_type},
          { name: 'plan_cost', label: 'Monthly Charges', type: 'number', placeholder: 'Ex: 499', icon: "dollar", requiredmsg: 'Must be filled and greater than zero.', description: "", suffix: "/month", maxlength: 15, minValue: 1},
          { name: 'annual_discount', label: 'Annual Discount', type: 'number', placeholder: 'Ex: 10', icon: "fi fi-br-badge-percent", requiredmsg: '', description: "Percentage", suffix: "%", maxlength: 15},
          { name: 'free_minutes', label: 'Free Minutes', type: 'number', placeholder: 'Ex: 1000', icon: "fi fi-br-alarm-clock", requiredmsg: 'Required field', maxlength: 15},
          { name: 'addon_cost_per_call', label: 'Extra Minute Charges', type: 'number', placeholder: 'Ex: 0.20', icon: "dollar", requiredmsg: 'Required field', maxlength: 15, minValue: 0.001},
          /* { name: 'setup_cost', label: 'Setup Cost', type: 'number', placeholder: 'Ex: 10', icon: "dollar", requiredmsg: '', description: "", suffix: "", maxlength: 3, minValue: 0}, */
          { name: 'is_popular', label: 'Mark as Most Popular', type: 'toggle', placeholder: '', icon: "", requiredmsg: '', maxlength: 15},
          /* { name: 'max_customers', label: 'Max Customers', type: 'number', placeholder: '', icon: "", maxlength: 15, requiredmsg: 'Required field'}, */
      ]
  },
  /* {
      title: 'Initial Services',
      fields: [
          { name: 'phone_numbers', label: 'Initial Phone Numbers', type: 'number', placeholder: 'Ex: 5', icon: "", requiredmsg: 'Initial Phone Numbers are required'},
          { name: 'agents', label: 'Initial Agents', type: 'number', placeholder: 'Ex: 10', icon: robot, requiredmsg: 'Initial Agents are required' },
          { name: 'addon_cost_per_number', label: 'Additional Cost Per Phone Number', type: 'number', placeholder: 'Ex: 5', icon: dollar, requiredmsg: ''},
          { name: 'addon_cost_per_agent', label: 'Additional Cost Per Agents', type: 'number', placeholder: 'Ex: 100', icon: dollar, requiredmsg: ''}
      ]
  }, */
  {
      title: 'Additional Services',
      fields: [
        { name: 'cus_desc_0', label: 'Custom Description 1', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_1', label: 'Custom Description 2', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_2', label: 'Custom Description 3', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_3', label: 'Custom Description 4', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_4', label: 'Custom Description 5', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_5', label: 'Custom Description 6', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_6', label: 'Custom Description 7', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_7', label: 'Custom Description 8', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_8', label: 'Custom Description 9', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
        { name: 'cus_desc_9', label: 'Custom Description 10', type: 'text', placeholder: '', requiredmsg: '', icon: emoji, group: "custom_desc", description: "Click Emoji to add to Emoji for Plan Page", maxlength: 100},
      ]
  }
];